<script>
  import { resolveStatusClass } from '@utils/status'

  export default {
    props: {
      status: {
        type: null,
        default: null,
      },
    },
    data() {
      return {
        finishedLoading: false,
      }
    },
    async created() {
      this.finishedLoading = true
    },
    methods: {
      resolveStatusClass,
    },
  }
</script>

<template>
  <span v-if="finishedLoading && status && status.key" class="block-status tw-flex align-items-center rounded-pill tw-pl-1 tw-pr-4" v-bind="$attrs">
    <span
      :class="[
        'status-icon',
        resolveStatusClass(status && status.key ? status.key.toLowerCase() : ''),
      ]"></span>
    <span class="status-text text-capitalize">{{ status.name }}</span>
  </span>
  <span v-else class="block-status tw-flex align-items-center rounded-pill tw-pl-1 tw-pr-4" v-bind="$attrs">
    <span class="status-icon status-inactive"></span>
    <span class="status-text text-capitalize">inactive</span>
  </span>
</template>
